import React from 'react';
import { Box } from '@material-ui/core';
import EnhancedTable from './tableOperations/EnhancedTable';
import { Title } from '../style';
import Search from './Search';

const Operations = () => (
  <>
    <Title>Opérations</Title>
    <Box mt={3} />
    <Search />
    <EnhancedTable />
  </>
);

export default Operations;
